import { createContext, useRef, type RefObject } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";

import ApplicationHeader from "@rio-cloud/rio-uikit/ApplicationHeader";
import ApplicationLayout from "@rio-cloud/rio-uikit/ApplicationLayout";

import { DefaultUserMenu } from "@rio-cloud/rio-user-menu-component";
import IframeResizer from "iframe-resizer-react";
import { config } from "../../config";

// Componentes específicos para o BACKOFFICE
const BackofficeNavItems = [
  {
    key: "challenges",
    route: <NavLink to="/backoffice/challenges">Desafios</NavLink>,
  },
  {
    key: "tips",
    route: <NavLink to="/backoffice/tips">Dicas de Navegação</NavLink>,
  },
];

const BackofficeHeader = () => {
  const userMenuItem = (
    <DefaultUserMenu
      environment={
        process.env.NODE_ENV === "development" ? "development" : "production"
      }
    />
  );

  return (
    <ApplicationHeader
      appNavigator={
        <IframeResizer
          className="iFrameResizer"
          src={config.backend.MENU_SERVICE}
        />
      }
      homeRoute={<Link to="/backoffice" />}
      label="RIO ROUTING - BACKOFFICE"
      navItems={BackofficeNavItems}
      actionBarItems={[userMenuItem]}
    />
  );
};

type AppContextType = { sidebarRef: RefObject<HTMLDivElement> | null };
const AppContext = createContext<AppContextType>({ sidebarRef: null });

// Layout específico para BACKOFFICE
const BackofficeLayout = () => {
  const sidebarRef = useRef<HTMLDivElement>(null);

  return (
    <AppContext.Provider value={{ sidebarRef }}>
      <ApplicationLayout data-testid="backoffice-layout">
        <ApplicationLayout.Header>
          <BackofficeHeader />
        </ApplicationLayout.Header>

        <ApplicationLayout.Body innerClassName="padding-0" className="padding-0 margin-0">
          <Outlet />
        </ApplicationLayout.Body>
      </ApplicationLayout>
    </AppContext.Provider>
  );
};

export default BackofficeLayout; 